module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "business"
  }, [_c('div', {
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "id": "page-top"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "business_intro"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("拉风汽车AI智能系统")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.titleMsg))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/imgs/business2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "business_main"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pattern"
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.msg2))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "bor"
  }, [_c('span', {
    staticClass: "borl"
  }), _c('span', [_vm._v("业务模式")]), _c('span', {
    staticClass: "borr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/business1.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "bor"
  }, [_c('span', {
    staticClass: "borl"
  }), _c('span', [_vm._v("主营业务")]), _c('span', {
    staticClass: "borr"
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('div', [_c('p', [_vm._v("库存融资业务")]), _vm._v(" "), _c('span', [_vm._v("模式多样化、利率更灵活、评估更专业精准，更好的解决车源留存及库存融资问题")])])]), _vm._v(" "), _c('li', [_c('div', [_c('p', [_vm._v("消费贷分期---新车、二手车")]), _vm._v(" "), _c('span', [_vm._v("手续更简单、风控模型更完善、审批流程更快捷、放款速度更高效"), _c('small', [_vm._v("进件提报>风控审核>合同签署>抵押放款")])])])]), _vm._v(" "), _c('li', [_c('div', [_c('p', [_vm._v("车辆评估业务")]), _vm._v(" "), _c('span', [_vm._v("具有真实收售数据支持，评估定价更精准；双评定价系统分析，彻底防范道德风险；标准化评估作业，实现车辆评估数据化，提高效率与质量")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7684747f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Business.vue
// module id = 206
// module chunks = 1